<template>
  <!--新增api模板-->
  <div class="contract-wrap">
    <h1 class="com-title com-ht" style="margin-bottom: 20px">
      <i></i>新增api模板<span class="ms"
        >/ 设置合同固定条款，智能生成合同信息</span
      >
    </h1>
    <el-container class="contract-tpl">
      <el-main class="main">
        <tpl-editor
          v-if="!$route.query.editorType"
          ref="tplEditor"
          @editorReadyCallback="handleEditorReadyCallback"
        />
        <iframe v-else ref="tipEditorRef" style="width: 100%; height: 60vh" :src="editorUrl" frameborder="0"></iframe>
      </el-main>

      <el-aside width="260px" class="aside">
        <h4>模板信息</h4>
        <el-form
          :model="tplFrm"
          :rules="tplFrmRules"
          ref="tplFrm"
          size="small"
          class="tpl-info"
        >
          <el-form-item prop="tplName">
            <el-input v-model="tplFrm.tplName" placeholder="模板名称" />
          </el-form-item>
          <el-form-item prop="serialNum">
            <el-input
              v-model="tplFrm.serialNum"
              placeholder="模板ID"
              v-if="$route.query.tplId"
              :disabled="true"
              :readonly="true"
            />
            <el-input
              v-model="tplFrm.serialNum"
              placeholder="模板ID"
              v-else
            />
          </el-form-item>
          <el-form-item prop="tplGroupTypeId" v-if="false">
            <el-select v-model="tplFrm.tplGroupTypeId">
              <el-option :key="-1" :label="'未分类'" :value="-1"></el-option>
              <el-option
                v-for="item in groupList"
                :key="item.tplGroupTypeId"
                :label="item.tplGroupTypeName"
                :value="item.tplGroupTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="false">
            <el-input
              v-model="tplFrm.mark"
              type="textarea"
              placeholder="备注"
            />
          </el-form-item>
          <el-form-item>
            <el-button @click="showToTplPre = true" class="btn">预览</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitTplFrm()" type="danger" class="btn"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </el-aside>

      <el-dialog :visible.sync="showToTplPre" title="模板预览" width="500px">
        <!-- :close-on-click-modal="false" -->
        <div>
          <textarea
            v-model="tplPreParams"
            cols="60"
            rows="10"
            placeholder="输入参数{key:value}"
          ></textarea>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="tplPre()" size="small" type="danger"
            >模拟</el-button
          >
          <el-button @click="tplPrePdf()" size="small" type="danger"
            >模拟pdf下载</el-button
          >
        </div>
      </el-dialog>
      <!--        :fullscreen="true"-->
      <el-dialog :visible.sync="showTplPre" title="模板预览" width="60%">
        <!-- <div class="a4_size"> -->
          <!-- <div v-html="tplPreContext"></div> -->
          <iframe :srcdoc="tplPreContext" :title="tplFrm.tplName" class="iframe-sty"></iframe>
        <!-- </div> -->
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import TplEditor from "../../../components/tpl-editor/index";
import { ApiMethods } from "../../../assets/js/http-serve/http-methods";
import Vue from "vue";
import GlobalConfig from '../../../assets/js/config/global';
export default {
  methods: {
    handleEditorReadyCallback () {
      var _this = this;
      _this.tplId = _this.$route.query.tplId;
      if (_this.tplId) {
        _this.loadTpl(_this.tplId);
      }
    },
    queryGroupTypeList: function () {
      var _this = this;
      ApiMethods.ApiTemplateController.tplGroupType({}).then(result => {
        if (result.success) {
          _this.groupList = result.data;
        } else {
          _this.$message.error(result.description || this.$tip);
        }
      });
    },
    submitTplFrm: function () {
      var _this = this;
      _this.$refs.tplFrm.validate(valid => {
        if (valid) {
          var contextHtml = ''
          let document = ''
          if (this.$route.query.editorType) {
            contextHtml = this.editorData
            document = '';
          } else {
            contextHtml = _this.$refs.tplEditor.editor.getData();
           document = _this.$refs.tplEditor.editor.document;
          }
          // var contextHtml = this.editorData
          // const document = '';
          if (document) {
            var contextText = document
              .getBody()
              .getText()
              .trim();
            if (!contextText || contextText.length < 1 || contextText === "") {
              return _this.$alert("请填写模板内容", "系统提示");
            }
          }
          if (!contextHtml || contextHtml === "") {
            return _this.$alert("模板内容不能为空", "系统提示");
          }
          var param = _this.tplFrm;
          param.context = contextHtml;
          param.editorType = this.$route.query.editorType;
          ApiMethods.ApiTemplateController.operTpl(param).then(result => {
            if (result.success) {
              _this.$alert("操作成功", "系统提示", {
                confirmButtonText: "确定",
                callback: action => {
                  let { control } = _this.$route.query;
                  if (control && control == 1) {
                    // 从控制台过来就返回控制台
                    _this.$router.go(-1);
                    return;
                  } else {
                    // 不知道这里跳转逻辑（与路由守卫企业用户冲突，报错）所以加了上面的判断
                    _this.$router.push({ path: "/tpl/general" });
                  }
                }
              });
            } else {
              _this.$message.error(result.description || this.$tip);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    loadTpl: function (tplId) {
      var _this = this;
      const loading = _this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      ApiMethods.ApiTemplateController.findTpl({ tplId: tplId }).then(
        result => {
          if (result.success) {
            _this.tplFrm = result.data;
            if (this.$route.query.editorType) {
              setTimeout(() => {
                this.parentPostMessageFn(result.data)
              }, 1000)
            } else {
              _this.$refs.tplEditor.setData(_this.tplFrm.context);
            }
          } else {
            _this.$message.error(result.description || this.$tip);
          }
        }
      ).finally(()=>{loading.close();});
    },
    tplPre: function () {
      var _this = this;
      var contextHtml = '';
      if (this.$route.query.editorType) {
        contextHtml = this.editorData;
      } else {
        contextHtml = _this.$refs.tplEditor.editor.getData();
      }
      if (!_this.tplPreParams || _this.tplPreParams == "") {
        return _this.$alert("请输入模拟参数，如没有记录请输入{}", "系统提示");
      }
      var param = {
        context: contextHtml,
        params: _this.tplPreParams,
        tplType: _this.tplFrm.tplType
      };
      ApiMethods.ApiTemplateController.execTpl(param).then(result => {
        if (result.success) {
          _this.tplPreContext = result.data;
          console.log('_this.tplPreContext',_this.tplPreContext);
          this.showTplPre = true;
        } else {
          _this.$message.error(result.description || this.$tip);
        }
      });
    },
    tplPrePdf: function () {
      var _this = this;
      var contextHtml = '';
      if (this.$route.query.editorType) {
        contextHtml = this.editorData;
      } else {
        contextHtml = _this.$refs.tplEditor.editor.getData();
      }
      if (!_this.tplPreParams || _this.tplPreParams == "") {
        return _this.$alert("请输入模拟参数，如没有记录请输入{}", "系统提示");
      }
      var param = {
        context: contextHtml,
        params: _this.tplPreParams,
        tplType: _this.tplFrm.tplType
      };
      return ApiMethods.ApiTemplateController.execTplPdf_down(param);
    },
    parentPostMessageFn(content) {
      let base64 = require('js-base64').Base64;
      const consoleToken = this.$store.getters.consoleToken ? JSON.parse(base64.decode(this.$store.getters.consoleToken.token)) : {};
      const userToken = this.$store.getters.token ? JSON.parse(base64.decode(this.$store.getters.token)) : {};
      const allToken = Object.assign({}, userToken, consoleToken);
      let token = base64.encode(JSON.stringify(allToken));
      this.$refs.tipEditorRef.contentWindow.postMessage({
        type: 'tipEditor_parent',
        content: {
          ...content,
          token,
        },
      }, '*')
    },
    tipEditorChangeFn(message)  {
      if (message.data.type === 'tipEditor_change') {
        console.log('监听到内容改变', message.data.content)
        this.editorData = message.data.content;
      }
    }
  },
  created () {
    var _this = this;
    _this.tplFrm.tplGroupTypeId = _this.$route.query.tplGroupTypeId || -1;
    _this.queryGroupTypeList();
  },
  data () {
    return {
      editorData: '',
      showToTplPre: false,
      showTplPre: false,
      tplPreParams: "",
      editorInfo: "",
      tplPreContext: "",
      groupList: [],
      tplFrm: { tplGroupTypeId: -1 },
      tplFrmRules: {
        tplName: [
          {
            validator: this.$validator.required,
            trigger: "change",
            message: "模板名称不能为空"
          },
          {
            validator: this.$validator.minLength,
            trigger: "change",
            minLength: 1,
            message: "模板名称不能少于1个字符"
          },
          {
            validator: this.$validator.maxLength,
            trigger: "change",
            maxLength: 50,
            message: "模板名称不能大于50个字符"
          }
        ],
        serialNum: [
          {
            validator: this.$validator.required,
            trigger: "change",
            message: "模板ID不能为空"
          },
          {
            validator: this.$validator.minLength,
            trigger: "change",
            minLength: 1,
            message: "模板ID不能少于1个字符"
          },
          {
            validator: this.$validator.maxLength,
            trigger: "change",
            maxLength: 50,
            message: "模板ID不能大于50个字符"
          }
        ]
        // tplGroupTypeId: [
        //   {validator: this.$validator.required, trigger: 'change', message: '分类称不能为空'}
        // ]
      }
    };
  },
  computed: {
    editorUrl() {
      return GlobalConfig.domain.jzqTplEditor + '/initialEditor'
    },
  },
  mounted() {
    this.handleEditorReadyCallback();
    window.addEventListener('message', this.tipEditorChangeFn)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.tipEditorChangeFn)
  },
  name: "contract",
  components: { TplEditor }
};
</script>

<style lang="less" scoped>
.iframe-sty{
  width: 100%;
  height: 100vh;
  /* 自定义滚动条样式 */
  .iframe-sty::-webkit-scrollbar, .iframe-sty::-moz-scrollbar{
    width: 12px; /* 设置滚动条宽度 */
  }

  .iframe-sty::-webkit-scrollbar-track, .iframe-sty::-moz-scrollbar-track{
    background-color: #f1f1f1; /* 滚动条轨道颜色 */
  }

  .iframe-sty::-webkit-scrollbar-thumb,.iframe-sty::-moz-scrollbar-thumb {
    background-color: #888; /* 滚动条滑块颜色 */
  }

  .iframe-sty::-webkit-scrollbar-thumb:hover,.iframe-sty::-moz-scrollbar-thumb:hover {
    background-color: #555; /* 滚动条滑块hover颜色 */
  }
}
.a4_size {
  /*width:774.0pt;*/
  /*padding:72.0pt 90.0pt;*/
  word-wrap: break-word;
  word-break: normal;
  border: 1px solid #e0e0e0;
  width: 912px;
  padding: 30px 62px;
  font-size: 20px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2);
  margin: 20px auto;
  min-height: 500px;
}
.contract-wrap {
  background: #ffffff;
  padding-bottom: 20px;
  width: 1326px;
}
.contract-tpl {
  width: 100%;
  .main {
    padding: 0 20px;
  }

  .aside {
    display: table-cell;
    border: 1px solid #d7d7d7;
    margin-right: 20px;

    .tpl-info {
      padding: 20px;

      .btn {
        width: 100%;
      }
    }

    h4 {
      color: #333333;
      font-size: 14px;
      font-weight: 500;
      line-height: 300%;
      background-color: #f2f2f2;
      text-align: center;
    }
  }
}

/deep/ .cke_contents {
  height: 500px !important;
}
</style>



// WEBPACK FOOTER //
// pages/tpl/add/api.vue